import {
  ZONES_FETCHING,
  FETCH_ZONES,
  FILTER_ZONES_BY_PATTERN,
  FIND_ZONE,
} from "../actions/types";

const initialState = {
  items: [],
  loadedItems: [],
  filteredItems: [],
  found: null,
  isFetching: false,
  loader: "",
  limit: 0,
  offset: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ZONES_FETCHING:
      return { ...state, isFetching: true };

    case FETCH_ZONES:
      return {
        ...state,
        items: action.payload.items,
        filteredItems: action.payload.loaded,
        loadedItems: action.payload.loaded,
        loader: action.payload.loader,
        isFetching: false,
      };

    case FIND_ZONE:
      return {
        ...state,
        items: [...state.items, action.payload],
      };

    default:
      return state;
  }
}
